var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ongoing',{on:{"done":_vm.addToPast}}),_c('div',{staticStyle:{"margin-top":"6px","margin-bottom":"6px"}},[_c('v-divider'),_c('v-divider'),_c('v-divider')],1),_c('past',{ref:"past_rides"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }